export function moveTab() {
  let array_tabs = []; // Javascript array to store "a" elements
  let array_panels = []; // Javascript fix to store "div" elements

  /* With Jquery we get all the elements a, which are inside a li
   whose parent is an element with class .nav-tabs */
  array_tabs = window.$('.nav-tabs li a');
  // For each tab element ...
  for (let i = 0; i < array_tabs.length; i++) {
    // with Jquery we ask which of them has the active class
    if (window.$(array_tabs[i]).hasClass('active')) {
      window.$(array_tabs[i]).removeClass('active'); // the class is removed from that element
      window.$(array_tabs[i + 1]).addClass('active'); // and is added to the following

      // Jquery gets all the elements that have the tab-pane class
      array_panels = window.$('.tab-pane');
      // for each panel ..
      for (let j = 0; j < array_panels.length; j++) {
        // wonders if it has the active class
        if (window.$(array_panels[j]).hasClass('active')) {
          window.$(array_panels[j]).removeClass('active show'); // the class is removed from that element
          window.$(array_panels[j + 1]).addClass('active show'); // the active and show class is added to the following to show
          return true;
        }
      }
    }
  }
}
